// extracted by mini-css-extract-plugin
export default {"bare":"buttons-bare-3Kbre"};